import React from 'react';

import classNames from 'classnames';

import CloseIcon from '../../components/order-detailed/icons/close-icon.svg';
import HintModal from '../../containers/hints/hint-modal';
import { RepeatableHintsType } from '../../services/api/dto/Accounts';
import IconBtn from '../icon-btn/icon-btn';

import './table-header-wrapper.scss';

interface TableHeaderWrapperProps {
  date?: string;
  status?: React.ReactNode;
  leftContent?: React.ReactNode;
  time?: string;
  onCloseClick?: () => void;
  isOrange?: boolean;
  isHint?: boolean;
  hintPage?: RepeatableHintsType;
}

const TableHeaderWrapper: React.FC<TableHeaderWrapperProps> = ({
  status,
  isOrange,
  date,
  onCloseClick,
  time,
  leftContent,
  isHint,
  hintPage,
}) => (
  <div
    className={classNames('table-header-top', {
      'table-header-top--orange': isOrange,
    })}
  >
    <div className="table-header-top__left">{leftContent && leftContent}</div>
    <div className="table-header-top__right">
      <div className="table-header-top__date">
        {date} <span>{time}</span>
      </div>
      <div className="table-header-top__status">{status && status}</div>

      {isHint && hintPage && <HintModal hint={hintPage} />}
      <div className="table-header-top__close">
        <IconBtn onClick={onCloseClick} icon={CloseIcon} />
      </div>
    </div>
  </div>
);

export default TableHeaderWrapper;
